import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { FormSelect } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Gene, geneExpressions, GeneExpression, blankGene } from '../../types/Gene.ts';

type GeneInputProps = {
  genes: Gene[];
  gene: Gene;
  setGene: (gene: Gene) => void;
  id: string;
}

export const ToggleSwitch = ({ id, selectedGene, homCheck, setHomCheck }: {
  id: string;
  selectedGene: Gene;
  homCheck: boolean;
  setHomCheck: Function;
}) => {
  return (
    <div id={id} className={`custom-control custom-switch ${homCheck ? 'active-switch' : ''}`}>
      <input type="checkbox" checked={homCheck} className="custom-control-input" />
      {selectedGene.gene_type !== '(Unproven)' && selectedGene.gene_type !== '(Line Bred)' && <label onClick={() => { setHomCheck(!homCheck) }} className="custom-control-label">{selectedGene && selectedGene.gene_type === "Recessive" ? 'Het' : 'Super'}</label>}
    </div>
  )
}


export const GeneInput = ({ genes, gene, setGene, id }: GeneInputProps) => {
  const [selectedGene, setSelectedGene] = useState<Gene[]>([blankGene]);
  const [isValid, setIsValid] = useState(!!genes.find((x) => x.gene_name === gene.gene_name));
  const [hasText, setHasText] = useState(false);
  const [currentTypedText, setCurrentTypedText] = useState("");
  useEffect(() => {
    setSelectedGene([gene]);
    setIsValid(!!genes.find((x) => x.gene_name === gene.gene_name));
  }, [gene]);


  let selectableExpressions = geneExpressions;
  if (gene.gene_type === "Recessive") {
    selectableExpressions = selectableExpressions.filter(expression => expression.value !== "SUPER")
  } else if (gene.gene_type === "Codom" || gene.gene_type === "Dominant") {
    selectableExpressions = selectableExpressions.filter(expression => expression.value === "SUPER" || expression.value === "NORMAL");
  } else {
    selectableExpressions = geneExpressions.filter(expression => expression.value === "NORMAL");
  }
  const disabledExpression = !gene.gene_name || !selectableExpressions;
  // filter out genes that don't have the label key
  return (
    <div>
      <div className={`has-validation`}>
        <div className="d-flex flex-row">
          <Typeahead
            className='flex-fill'
            id={id}
            key={`${id}-${selectedGene.length ? selectedGene[0].gene_name : ""}`}
            isValid={Boolean(isValid && selectedGene.length && selectedGene[0].gene_name)}
            onChange={(selected) => {
              const options = selected as Gene[];
              if (options.length) {
                const selectedGene = genes.find((x) => x.gene_name === options[0].gene_name);
                if (selectedGene) {
                  setGene({ ...selectedGene, expression: "NORMAL" });
                  setCurrentTypedText(selectedGene.gene_name);
                  setIsValid(true);
                } else {
                  setIsValid(false);
                }
              } else {
                setGene({ ...blankGene, expression: "NORMAL", gene_name: currentTypedText });
                setIsValid(false);
              }
            }}
            onInputChange={(event) => {
              setHasText(event !== "");
              setCurrentTypedText(event);
              const foundGene = genes.find((x) => x.gene_name === event);
              setIsValid(!!foundGene);
            }}
            onBlur={() => {
              const foundGene = genes.find((x) => x.gene_name.toLowerCase() === currentTypedText.toLowerCase());
              if (foundGene) {
                setGene({ ...foundGene, expression: "NORMAL" });
                setIsValid(true);
              }
            }}
            placeholder={"Gene Name"}
            labelKey={"gene_name"}
            defaultSelected={selectedGene}
            options={genes}
          />
          {hasText && <FontAwesomeIcon icon={faTimes} size='xl' className={`clear-gene text-danger my-auto ml-3 ${selectedGene.length ? '' : 'd-none'}`} onClick={() => { setSelectedGene([]); setGene(blankGene); }} />}
        </div>
        {!isValid && hasText && <div className="text-danger">Gene is unknown. Ignoring</div>}
      </div>

      <div className='d-flex flex-row'>
        <FormSelect
          id={`expression-select-${gene.id}`}
          value={gene.expression}
          size='sm'
          disabled={disabledExpression}
          className={`text-left my-3`}
          style={{ width: 'min-content', opacity: disabledExpression ? 0.5 : 1 }}
          onChange={(e) => {
            setGene({ ...gene, expression: e.target.value as GeneExpression });
          }}
        >
          {selectableExpressions.map(expression => (
            <option value={expression.value}>
              {expression.label}
            </option>
          ))}
        </FormSelect>
      </div>
    </div>

  )
}